import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';
import { parseISO } from 'date-fns';
import { dateFNSLocale, localeFormat } from '../../utils/date';

const WorkshopDate = ({ startDate }) => {
  if (!startDate) return null;
  const dateOptions = { locale: dateFNSLocale() };
  return (
    <>
      <Icon name="calendar alternate outline" />
      {localeFormat(parseISO(startDate), 'PP', dateOptions)}
      <Icon name="clock" style={{ marginLeft: 10 }} />
      {localeFormat(parseISO(startDate), 'p', dateOptions)}
    </>
  );
};

WorkshopDate.defaultProps = {
  startDate: undefined,
};

WorkshopDate.propTypes = {
  startDate: PropTypes.string,
};

export default WorkshopDate;
